import { getRoutesFromFiles } from '@sorare/routing';

export const routeObjects = getRoutesFromFiles(
  import.meta.glob('./**/(page|layout).tsx')
);
